export default class AxIconChip {
    // TODO keyboard accessibility?
    // TODO optional starting width?
    // TODO chip icon colours
    private static readonly contractedWidth: string = '220px';
    private static readonly contractedHeight: string = '40px';
    private static chipIsResponsive: boolean = false;

    private static setStyle(el: HTMLElement, sel: string, prop: string, val: string) {
        const targetEl = el.querySelector(sel) as HTMLElement;
        targetEl.style[(prop as any)] = val;
    }

    private static setInitStyles(chipInstance: HTMLElement) {
        AxIconChip.setStyle(chipInstance, '.ax-icon-chip__label', 'overflow', 'hidden');
        AxIconChip.setStyle(chipInstance, '.ax-icon-chip__label', 'whiteSpace', 'nowrap');
        AxIconChip.setStyle(chipInstance, '.ax-icon-chip__sublabel', 'overflow', 'hidden');
        AxIconChip.setStyle(chipInstance, '.ax-icon-chip__sublabel', 'whiteSpace', 'nowrap');

        if(AxIconChip.chipIsResponsive) {
            chipInstance.classList.add("ax-icon-chip--responsive");
        } else {
            chipInstance.classList.remove("ax-icon-chip--responsive");
            chipInstance.style.width = AxIconChip.contractedWidth;
        }
        

        chipInstance.style.height = AxIconChip.contractedHeight;
        chipInstance.style.zIndex = 'auto';
        AxIconChip.setStyle(chipInstance, '.ax-icon-chip__backdrop', 'width', '100%');
        AxIconChip.setStyle(chipInstance, '.ax-icon-chip__backdrop', 'height', '100%');
        AxIconChip.setStyle(chipInstance, '.ax-icon-chip__label', 'width', 'calc(100%)');
        AxIconChip.setStyle(chipInstance, '.ax-icon-chip__sublabel', 'width', 'calc(100%)');
        AxIconChip.setStyle(chipInstance, '.ax-icon-chip__label', 'max-width', 'calc(100%)');
        AxIconChip.setStyle(chipInstance, '.ax-icon-chip__sublabel', 'max-width', 'calc(100%)');
    }

    private static resetStyles(chipInstance: HTMLElement) {
        chipInstance.removeAttribute('style');
        chipInstance.querySelector('.ax-icon-chip__label')?.removeAttribute('style');
        chipInstance.querySelector('.ax-icon-chip__sublabel')?.removeAttribute('style');
    }

    public static expand(chipInstance: HTMLElement) {
        const chip = chipInstance.closest(".ax-icon-chip") as HTMLElement;
        const chipLabel = chip.querySelector('.ax-icon-chip__label') as HTMLElement;
        const chipSublabel = chip.querySelector('.ax-icon-chip__sublabel') as HTMLElement;
        const chipIcon = chip.querySelector('.ax-icon-chip__icon') as HTMLElement;
        const chipBackdrop = chip.querySelector('.ax-icon-chip__backdrop') as HTMLElement;
        let chipVertPadding = 10;
        let toWindowEdge = window.innerWidth - chip.getBoundingClientRect().left;

        // minus icon width, padding around icon, padding right of chip:
        let chipIconWidth = chipIcon.clientWidth + chipVertPadding + 12;

        let labelScrollWidth = chipLabel.scrollWidth + chipIconWidth;
        let subLabelScrollWidth = chipSublabel.scrollWidth + chipIconWidth;
        let biggestScrollWidth = Math.max(labelScrollWidth, subLabelScrollWidth);

        let labelExpandWidth = Math.min(biggestScrollWidth, toWindowEdge - chipIconWidth );
        let backdropExpandWidth = Math.min(biggestScrollWidth, toWindowEdge);

        chip.style.zIndex = '9999';
        chipLabel.style.width = labelExpandWidth + "px";
        chipLabel.style.maxWidth = labelExpandWidth + "px";
        chipSublabel.style.width = labelExpandWidth + "px";
        chipSublabel.style.maxWidth = labelExpandWidth + "px";

        chipBackdrop.style.width = backdropExpandWidth + "px";
        chipBackdrop.style.maxWidth = backdropExpandWidth + "px";

        // Deal with height if long text
        setTimeout(() => {
            chipLabel.style.whiteSpace = 'normal';
            chipSublabel.style.whiteSpace = 'normal';
            chipLabel.style.overflow = 'unset';
            chipSublabel.style.overflow = 'unset';
            chipBackdrop.style.height = chipLabel.clientHeight + chipSublabel.clientHeight + chipVertPadding + "px";
        }, 100); // Timeout must equal max-width transition time in icon-chip.scss

        (chipInstance as any).isExpanded = true;
    };

    public static shrink(chipInstance: HTMLElement) {
        AxIconChip.setInitStyles(chipInstance);

        (chipInstance as any).isExpanded = false;
    }

    public static itemClick(chipInstance: HTMLElement) {
        const itemClickHandler = (event: Event) => {
            if ((chipInstance as any).isExpanded == true) {
                AxIconChip.shrink(chipInstance);
            } else {
                AxIconChip.expand(chipInstance);
            }
        }
        (chipInstance as any).itemClickHandler = itemClickHandler;
        return itemClickHandler
    }

    public static documentClick(chipInstance: HTMLElement) {
        const documentClickHandler = (event: Event) => {
            let path = (event as any).path || (event.composedPath && event.composedPath()); //For chips in web components

            if (
                chipInstance.contains((event.target as HTMLElement))
                || chipInstance.contains((path[0] as any))
            ) return;

            if ((chipInstance as any).isExpanded === true) {
                AxIconChip.shrink(chipInstance);
            }
        }

        (chipInstance as any).documentClickHandler = documentClickHandler;
        return documentClickHandler
    }

    public static init(item: HTMLElement, isResponsive = false) {
        AxIconChip.chipIsResponsive = isResponsive;

        if (!item) return;
        if ((item as any).isInitialised == true) return;

        // Wrap children
        let itemChildren = [...item.children]
        item.appendChild(document.createElement("div")).setAttribute('class', 'ax-icon-chip__backdrop');
        itemChildren.forEach((child) => {
            item.querySelector('.ax-icon-chip__backdrop')?.appendChild(child);
        })

        AxIconChip.setInitStyles(item);
        item.addEventListener("click", AxIconChip.itemClick(item));
        document.addEventListener("click", AxIconChip.documentClick(item));
        (item as any).isInitialised = true;
    }

    public static destroy(item: HTMLElement) {
        if ((item as any).isInitialised == false) return;
        // Unwrap children
        let itemBackdrop = item.querySelector('.ax-icon-chip__backdrop');
        if (!!itemBackdrop) {
            let itemChildren = [...itemBackdrop.children];
            itemChildren.forEach((child) => {
                item.appendChild(child);
            });
            item.removeChild(itemBackdrop);
        }

        AxIconChip.resetStyles(item);
        item.removeEventListener("click", (item as any).itemClickHandler);
        document.removeEventListener("click", (item as any).documentClickHandler);
        (item as any).isInitialised = false;
    }
};
